import { Link } from 'react-router-dom';
import WorkCard from '@/components/feature/WorkCard';
import { works } from '@/mocks/catalog';

const editors = [
  { id: 'the-mountain-sings', note: '四年、十一座山系，把四季拍成一部电影。适合周末安静地看完。' },
  { id: 'the-lost-arcade', note: '关于旧街机厅的温柔想象，画面和配乐都值得戴上耳机。' },
  { id: 'deepwater-archive', note: '八集迷你剧，节奏紧凑，深夜观看体验最佳。' },
];

export default function EditorSpotlight() {
  const list = editors
    .map((entry) => ({ note: entry.note, work: works.find((w) => w.id === entry.id) }))
    .filter((item) => item.work);

  return (
    <section className="w-full bg-background-100/70 px-4 py-12 md:px-8 md:py-16">
      <div className="mx-auto w-full max-w-[1400px]">
        <div className="flex flex-wrap items-end justify-between gap-3">
          <div>
            <p className="font-label text-xs uppercase tracking-[0.2em] text-accent-600">Editor's Picks</p>
            <h2 className="mt-2 font-display text-2xl font-bold text-foreground-950 md:text-3xl">编辑精选</h2>
          </div>
          <Link to="/news" className="flex items-center gap-1 whitespace-nowrap text-sm text-foreground-600 hover:text-accent-700">
            更多推荐理由 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-6 grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-5 lg:grid-cols-4">
          {list.map(({ work, note }) => (
            <div key={work!.id} className="flex flex-col">
              <WorkCard work={work!} />
              <p className="mt-2.5 line-clamp-2 text-xs leading-relaxed text-foreground-500">
                <span className="font-semibold text-accent-700">编辑说：</span>
                {note}
              </p>
            </div>
          ))}
          <div className="col-span-2 flex flex-col justify-between rounded-lg border border-background-300/60 bg-background-50 p-5 md:col-span-1">
            <div>
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                <i className="ri-bookmark-3-line text-base"></i>
              </span>
              <h3 className="mt-3 font-display text-base font-bold text-foreground-950">建立你的专属片单</h3>
              <p className="mt-2 text-xs leading-relaxed text-foreground-500">
                在任意作品详情页点击「收藏」，作品会自动保存到本地片单，刷新页面也不会丢失。
              </p>
            </div>
            <Link
              to="/favorites"
              className="mt-4 flex items-center justify-between rounded-md bg-primary-950 px-3.5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-800"
            >
              查看我的收藏
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}